export default __webpack_public_path__ + "static/media/ship.beca3857.svg";